import { Box, Typography } from '@mui/material';

import { PaginatedDealsTable } from './PaginatedDealsTable';

export const MyDeals = () => {
    return (
        <Box mt={3.5} pt={2} sx={{ minHeight: '100%' }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box display="flex" flexDirection="row" flexWrap="wrap" alignItems="center">
                    <Typography mb={0.5} variant="h5">
                        Withdrawals
                    </Typography>
                </Box>
            </Box>
            <Box mt={2}>
                <PaginatedDealsTable />
            </Box>
        </Box>
    );
};
